"use strict";import{IconsLarge as e}from"./src/IconsLarge.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icons-large",e);
//# sourceMappingURL=sp-icons-large.js.map
